(function () {
  "use strict";

  var ITERATIONS = 310000;

  function decodeBase64(value) {
    var binary = atob(value.replace(/\s+/g, ""));
    var bytes = new Uint8Array(binary.length);
    for (var index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }
    return bytes;
  }

  async function decryptConfig(password, encryptedElement) {
    var passwordKey = await crypto.subtle.importKey(
      "raw",
      new TextEncoder().encode(password),
      "PBKDF2",
      false,
      ["deriveKey"]
    );
    var key = await crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: decodeBase64(encryptedElement.dataset.salt),
        iterations: ITERATIONS,
        hash: "SHA-256"
      },
      passwordKey,
      { name: "AES-GCM", length: 256 },
      false,
      ["decrypt"]
    );
    var plaintext = await crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: decodeBase64(encryptedElement.dataset.iv),
        tagLength: 128
      },
      key,
      decodeBase64(encryptedElement.textContent)
    );
    var config = JSON.parse(new TextDecoder().decode(plaintext));

    if (!config || config.version !== 1 || !config.inputs) {
      throw new Error("Invalid planner configuration");
    }
    return config;
  }

  function loadCalculator(root) {
    return new Promise(function (resolve, reject) {
      if (globalThis.AmieLtvCacModel) {
        resolve();
        return;
      }

      var script = document.createElement("script");
      script.src = root.dataset.calculatorScript;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initializeGate(lock) {
    var form = lock.querySelector("[data-ltv-password-form]");
    var input = lock.querySelector("[data-ltv-password]");
    var button = lock.querySelector("[data-ltv-unlock]");
    var error = lock.querySelector("[data-ltv-password-error]");
    var root = document.querySelector("[data-ltv-cac-app]");
    var encryptedElement = root && root.querySelector("[data-ltv-encrypted-config]");

    if (!form || !input || !button || !root || !encryptedElement) return;

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      var password = input.value.trim();

      if (!password) {
        error.textContent = "Enter the shared password.";
        input.focus();
        return;
      }

      button.disabled = true;
      button.textContent = "Unlocking…";
      error.textContent = "";

      try {
        var config = await decryptConfig(password, encryptedElement);
        var configElement = document.createElement("script");
        configElement.type = "application/json";
        configElement.setAttribute("data-ltv-config", "");
        configElement.textContent = JSON.stringify(config);
        root.prepend(configElement);

        await loadCalculator(root);
        input.value = "";
        root.hidden = false;
        root.setAttribute("aria-hidden", "false");
        lock.hidden = true;
        document.title = "Internal LTV:CAC Planner | Amie";
        window.scrollTo({ top: 0, behavior: "instant" });
      } catch (unlockError) {
        error.textContent = "That password isn’t correct. Try again.";
        input.select();
        button.disabled = false;
        button.textContent = "Unlock planner";
      }
    });

    root.querySelector("[data-lock-planner]")?.addEventListener("click", function () {
      window.location.reload();
    });

    window.setTimeout(function () { input.focus(); }, 50);
  }

  function initialize() {
    document.querySelectorAll("[data-ltv-lock]").forEach(initializeGate);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
